module.exports = __webpack_public_path__ + "static/tasks-web1-dbe14332e55272e50b2fc87dadcf4c94.png";